<div class="bg-m0 max-h-[92vh] overflow-y-auto p-6 sm:p-9">
  <div
    data-cy="addProviderDialogTitle"
    class="text-s2 mt-2 text-left text-2xl font-semibold sm:mt-5"
    >Add Provider</div
  >
  <form
    class="mt-8 flex w-full max-w-[720px] flex-col"
    [formGroup]="addProviderForm"
    (ngSubmit)="add()"
  >
    <div class="mb-8 flex flex-col sm:flex-row sm:items-start">
      <label class="mb-2 w-[200px] flex-shrink-0 font-semibold sm:mb-0 sm:mt-3"
        >Type</label
      >
      <ng-select
        #addProviderDialogTypeSelect
        [fixNgSelectBottom]="addProviderDialogTypeSelect"
        data-cy="addProviderDialogTypeSelect"
        class="w-full"
        [items]="providerTypes"
        bindLabel="label"
        bindValue="value"
        [clearable]="false"
        [searchable]="false"
        appendTo="body"
        formControlName="type"
        (keyup.esc)="
          $event.stopImmediatePropagation(); addProviderDialogTypeSelect.blur()
        "
      >
        <ng-template ng-option-tmp let-item="item">
          <div
            [class.cursor-default]="item.isAlreadySelected"
            [class.text-s400]="item.isAlreadySelected"
            tp="Provider is already added"
            [tpIsEnabled]="item.isAlreadySelected"
          >
            {{ item.label }}
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div
      *ngIf="isOpenAICompatible"
      class="flex flex-col sm:flex-row sm:items-start"
    >
      <label class="mb-2 w-[200px] flex-shrink-0 font-semibold sm:mb-0 sm:mt-3"
        >Provider ID</label
      >
      <div class="flex w-full flex-col">
        <input
          autocomplete="off"
          spellcheck="false"
          data-cy="addProviderDialogProviderIdInput"
          class="form-input border-s3 focus:border-m600 w-full rounded"
          formControlName="providerId"
        />
        <m-validation
          [control]="addProviderForm.controls['providerId']"
        ></m-validation>
      </div>
    </div>

    <div
      *ngIf="isOpenAICompatible"
      class="mt-1 flex flex-col sm:flex-row sm:items-start"
    >
      <label class="mb-2 w-[200px] flex-shrink-0 font-semibold sm:mb-0 sm:mt-3"
        >Name</label
      >
      <div class="flex w-full flex-col">
        <input
          autocomplete="off"
          spellcheck="false"
          data-cy="addProviderDialogNameInput"
          class="form-input border-s3 focus:border-m600 w-full rounded"
          formControlName="name"
        />
        <m-validation
          [control]="addProviderForm.controls['name']"
        ></m-validation>
      </div>
    </div>

    <div
      *ngIf="isOpenAICompatible"
      class="mt-1 flex flex-col sm:flex-row sm:items-start"
    >
      <label class="mb-2 w-[200px] flex-shrink-0 font-semibold sm:mb-0 sm:mt-3"
        >Base URL</label
      >
      <div class="flex w-full flex-col">
        <input
          autocomplete="off"
          spellcheck="false"
          data-cy="addProviderDialogBaseUrlInput"
          class="form-input border-s3 focus:border-m600 w-full rounded"
          formControlName="baseURL"
          placeholder="https://api.example.com/v1"
        />
        <m-validation
          [control]="addProviderForm.controls['baseURL']"
        ></m-validation>
      </div>
    </div>

    <div
      *ngIf="usesApiKey"
      class="flex flex-col sm:flex-row sm:items-start"
      [class.mb-6]="isOpenAICompatible"
      [class.mt-1]="isOpenAICompatible"
    >
      <label class="mb-2 w-[200px] flex-shrink-0 font-semibold sm:mb-0 sm:mt-3"
        >API Key</label
      >
      <div class="flex w-full flex-col">
        <input
          autocomplete="off"
          spellcheck="false"
          data-cy="addProviderDialogApiKeyInput"
          class="form-input border-s3 focus:border-m600 w-full rounded"
          formControlName="apiKey"
          [placeholder]="isOpenAICompatible ? 'Optional' : 'Required'"
          type="text"
        />
        <m-validation
          *ngIf="!isOpenAICompatible"
          [control]="addProviderForm.controls['apiKey']"
        ></m-validation>
        <div *ngIf="isOpenAICompatible" class="text-s400 mt-1 text-sm"
          >Will be sent as Authorization: Bearer &lt;key&gt;</div
        >
      </div>
    </div>

    <div *ngIf="isOpenAICompatible" class="border-s300 mb-8 border-t pt-7">
      <div class="mb-4 flex items-center justify-between"
        ><div class="text-lg font-semibold">Headers</div
        ><button
          data-cy="addProviderDialogAddHeaderButton"
          class="border-s400 text-s500 hover:bg-s100 h-10 rounded border px-4 text-base shadow-sm focus:outline-none"
          type="button"
          (click)="addHeader()"
          >Add Header</button
        ></div
      >
      <div formArrayName="headers">
        <div
          *ngFor="let header of getHeaders().controls; let i = index"
          [formGroupName]="i"
          class="mb-3 flex gap-3"
        >
          <button
            class="text-s500 h-10 w-10"
            type="button"
            (click)="removeHeader({ index: i })"
            ><m-trash-icon></m-trash-icon
          ></button>
          <input
            class="form-input border-s3 focus:border-m600 flex-1 rounded"
            formControlName="key"
            placeholder="Key"
          />
          <input
            class="form-input border-s3 focus:border-m600 flex-1 rounded"
            formControlName="value"
            placeholder="Value"
          />
        </div>
      </div>
    </div>

    <div *ngIf="isOpenAICompatible" class="border-s300 mb-2 border-t pt-7">
      <div class="mb-4 flex items-center justify-between"
        ><div class="text-lg font-semibold">Query Parameters</div
        ><button
          data-cy="addProviderDialogAddQueryParamButton"
          class="border-s400 text-s500 hover:bg-s100 h-10 rounded border px-4 text-base shadow-sm focus:outline-none"
          type="button"
          (click)="addQueryParam()"
          >Add Parameter</button
        ></div
      >
      <div formArrayName="queryParams">
        <div
          *ngFor="let queryParam of getQueryParams().controls; let i = index"
          [formGroupName]="i"
          class="mb-3 flex gap-3"
        >
          <button
            class="text-s500 h-10 w-10"
            type="button"
            (click)="removeQueryParam({ index: i })"
            ><m-trash-icon></m-trash-icon
          ></button>
          <input
            class="form-input border-s3 focus:border-m600 flex-1 rounded"
            formControlName="key"
            placeholder="Key"
          />
          <input
            class="form-input border-s3 focus:border-m600 flex-1 rounded"
            formControlName="value"
            placeholder="Value"
          />
        </div>
      </div>
    </div>

    <div class="mt-6 flex items-center">
      <button
        data-cy="addProviderDialogAddButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Add</button
      >
      <button
        data-cy="addProviderDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
